import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { usePresentacionContext } from "../context/presentacion.context";
import { NumericFormat } from "react-number-format";
import { GetDateLocal } from "../../shared/utilitties/formatDate";
import { Badge } from "primereact/badge";
import moment from "moment";
import { Tooltip } from "primereact/tooltip";
import {
  consultarTransaccionesConDetalleMF,
  transaccionesExcluir,
  transaccionesIncluir,
} from "../services/transacciones.service";
import { createTransaccionAdapter, transaccionesDetallesMFAdapter, transaccionesMFAdapter } from "../adapters/transaccion.adapter";
import {
    INICIADA_COMERCIO, RECHAZADA,
} from "../utilities/constants";
import {
  TRANSACCIONES_DISPONIBLES,
  TRANSACCIONES_SELECCIONADAS,
} from "../../shared/utilitties/constants";

import {
  MESSAGE_ERROR_EXCLUIR_TRANSACCIONES_DETALLES,
  MESSAGE_ERROR_TRANSACCIONES_DETALLES,
  MESSAGE_FAILED_TRANSACCIONES_DETALLES,
  MESSAGE_NO_HAY_TRANSACIONES_SELECCIONADAS,
  MESSAGE_TRX_FECHA_MAYOR_90_DS,
} from "../utilities/messages.utilities";

import "./TransaccionesDataTable.css";

interface DataTableExpandedRows {
  [key: string]: boolean;
}
interface Props {
  setMask: Function;
}

const TransaccionesDetallesMF = (props: Props) => {
  const {
    presentacion,
    detailsTxDisponibles,
    detailsTxSeleccionadas,
    setDetailsTxDisponibles,
    setDetailsTxSeleccionadas,
    selectedTxSeleccionadas,
    setSelectedTxSeleccionadas,
    presentacionEditable,
    presentacionComercio,
    selectedProductoComercio,
    setSumTDisponibles,
    setSumTSeleccionadas,setPresupuestosList,setTotalImpuestosMF
  } = usePresentacionContext();

  const [expandedRowsDisponibles, setExpandedRowsDisponibles] = useState<
    any[] | DataTableExpandedRows
  >([]);
  const [selectedTxDisponibles, setSelectedTxDisponibles] = useState<any[]>([]);
  const [checkedAllDisponibles, setCheckedAllDisponibles] = useState(false);

  const [expandedRowsSeleccionadas, setExpandedRowsSeleccionadas] = useState<
    any[] | DataTableExpandedRows
  >([]);
  const [checkedAllSeleccionadas, setCheckedAllSeleccionadas] = useState(false);
  const [spinnerTxDisponibles, setSpinnerTxDisponibles] = useState(false);
  const [spinnerTxSeleccionadas, setSpinnerTxSeleccionadas] = useState(false);

  const toast = useRef<Toast>(null);
  const isMounted = useRef(false);
  const dt = useRef(null);
  useEffect(() => {
    if (isMounted.current) {
      const summary =
        expandedRowsDisponibles !== null
          ? "All Rows Expanded"
          : "All Rows Collapsed";
      // toast.current.show({severity: 'success', summary: `${summary}`, life: 3000});
    }
  }, []);

  const expandAll = (id: number) => {
    let _expandedRows: any = {};
    if (id == 1) {
      detailsTxDisponibles.forEach(
        (p: any) => (_expandedRows[`${p.idTransaccion}`] = true)
      );
      setExpandedRowsDisponibles(_expandedRows);
    } else {
      detailsTxSeleccionadas.forEach(
        (p: any) => (_expandedRows[`${p.idTransaccion}`] = true)
      );
      setExpandedRowsSeleccionadas(_expandedRows);
    }
  };

  const collapseAll = (id: number) => {
    id === TRANSACCIONES_DISPONIBLES
      ? setExpandedRowsDisponibles([])
      : setExpandedRowsSeleccionadas([]);
  };
  const allowExpansion = (rowData: any) => {
    return rowData.detalles.length > 0;
  };

  const exportExcel = (id: number) => {
    import("xlsx").then((xlsx) => {
      if (id === TRANSACCIONES_DISPONIBLES) {
        let transacciones:any= []
        detailsTxDisponibles.forEach((item:any) =>{
          let it = transaccionesMFAdapter(item)
          transacciones.push(it)
        })
        const worksheet = xlsx.utils.json_to_sheet(transacciones);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        saveAsExcelFile(excelBuffer, "TransaccionesDisponibles");

        let txd: any[] = [];
        detailsTxDisponibles.forEach((item: any) => {
          let txDetail = item.detalles;
          txDetail.forEach((it: any) => {
            let detail= transaccionesDetallesMFAdapter(it)
            txd.push(detail);
          });
        });

        const worksheet2 = xlsx.utils.json_to_sheet(txd);
        const workbook2 = {
          Sheets: { data: worksheet2 },
          SheetNames: ["data"],
        };
        const excelBuffer2 = xlsx.write(workbook2, {
          bookType: "xlsx",
          type: "array",
        });
        saveAsExcelFile(excelBuffer2, "DetalleTransaccionesDisponibles");
      } else {
        let transacciones:any= []
        detailsTxSeleccionadas.forEach((item:any) =>{
          let it = transaccionesMFAdapter(item)
          transacciones.push(it)
        })
        const worksheet = xlsx.utils.json_to_sheet(transacciones);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        saveAsExcelFile(excelBuffer, "TransaccionesSeleccionadas");

        let txd: any[] = [];
        detailsTxSeleccionadas.forEach((item: any) => {
          let txDetail = item.detalles;
          txDetail.forEach((it: any) => {
            let detail= transaccionesDetallesMFAdapter(it)
            txd.push(detail);
          });
        });
        const worksheet2 = xlsx.utils.json_to_sheet(txd);
        const workbook2 = {
          Sheets: { data: worksheet2 },
          SheetNames: ["data"],
        };
        const excelBuffer2 = xlsx.write(workbook2, {
          bookType: "xlsx",
          type: "array",
        });
        saveAsExcelFile(excelBuffer2, "DetalleTransaccionesSeleccionadas");
      }
    });
  };
  const saveAsExcelFile = (buffer: BlobPart, fileName: string) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };

  const onIncluirTxDisponibles = async () => {
    if(selectedTxDisponibles.length === 0){
      toast.current?.show({severity: 'warn', summary: 'Message', detail: MESSAGE_NO_HAY_TRANSACIONES_SELECCIONADAS, life: 5000});
      return;
    } 
    
    props.setMask(true)
    let precupon = "";
    setSpinnerTxSeleccionadas(true);
    if (window.location.href.indexOf("presentacion=") > 0) {
      precupon = window.location.href.split("=")[1];
    } else {
      precupon = presentacion;
    }

    setSpinnerTxDisponibles(true);
    let Tx = selectedTxDisponibles.map((tx: any) => {
      return createTransaccionAdapter(tx);
    });
    const data = {
      IdAfiliado: 0,
      PreCupon: parseInt(precupon),
      TransaccionesIncluir: Tx,
    };
    const resultIncluirTx = await transaccionesIncluir(data);
    if (resultIncluirTx.status === 200) {
      if(resultIncluirTx.data == 0){
        let resultTxMF = await consultarTransaccionesConDetalleMF(presentacion,selectedProductoComercio.grupoProductoId)
        if(resultTxMF.status === 200){
          let txIdList = resultTxMF.data.transaccionesSeleccionadas.map((item:any) => item.idPresupuesto).join()
          setPresupuestosList(txIdList)
          setDetailsTxDisponibles(resultTxMF.data.transaccionesDisponibles);
          setDetailsTxSeleccionadas(resultTxMF.data.transaccionesSeleccionadas);
          setSumTDisponibles(resultTxMF.data.totalesDisponibles.total);
          setSumTSeleccionadas(resultTxMF.data.totalesSeleccionadas.total);
          setTotalImpuestosMF(resultTxMF.data.totalesSeleccionadas.impuesto)
        }
        
      }else{
        if(resultIncluirTx.data == 9){
          toast.current?.show({severity: 'warn', summary: 'Message', detail: MESSAGE_FAILED_TRANSACCIONES_DETALLES, life: 5000});
          setSpinnerTxDisponibles(false);
          setSpinnerTxSeleccionadas(false);
        }
        props.setMask(false)
      }
    }else{
      toast.current?.show({severity: 'error', summary: 'Message', detail: MESSAGE_ERROR_TRANSACCIONES_DETALLES, life: 5000})
      props.setMask(false)
    }
    props.setMask(false)
    setSpinnerTxDisponibles(false);
    setSpinnerTxSeleccionadas(false);
    setSelectedTxDisponibles([]);
  };
  
  const onExcluirTxSeleccionadas = async () => {
    if(selectedTxSeleccionadas.length === 0) {
      toast.current?.show({severity: 'warn', summary: 'Message', detail: MESSAGE_NO_HAY_TRANSACIONES_SELECCIONADAS, life: 5000});
      return;
    }

    props.setMask(true)
    let precupon = "";
    
    setSpinnerTxDisponibles(true)
    if (window.location.href.indexOf("presentacion=") > 0) {
      precupon = window.location.href.split("=")[1];
    } else {
      precupon = presentacion;
    }

    setSpinnerTxSeleccionadas(true);
    let Tx = selectedTxSeleccionadas.map((item:any) => {
      return createTransaccionAdapter(item);
    });
    const data = {
      IdAfiliado: 0,
      PreCupon: parseInt(precupon),
      TransaccionesExcluir: Tx,
    };
    const resultExcluirTx = await transaccionesExcluir(data);
    if (resultExcluirTx.status === 200) {
      let resultTxMF = await consultarTransaccionesConDetalleMF(presentacion,selectedProductoComercio.grupoProductoId)
        if(resultTxMF.status === 200){
          let txIdList = resultTxMF.data.transaccionesSeleccionadas.map((item:any) => item.idPresupuesto).join()
          setPresupuestosList(txIdList)
          setDetailsTxDisponibles(resultTxMF.data.transaccionesDisponibles);
          setDetailsTxSeleccionadas(resultTxMF.data.transaccionesSeleccionadas);
          setSumTDisponibles(resultTxMF.data.totalesDisponibles.total);
          setSumTSeleccionadas(resultTxMF.data.totalesSeleccionadas.total);
          setTotalImpuestosMF(resultTxMF.data.totalesSeleccionadas.impuesto)
        }
    }else{
      toast.current?.show({severity: 'error', summary: 'Message', detail: MESSAGE_ERROR_EXCLUIR_TRANSACCIONES_DETALLES, life: 5000})
      props.setMask(false)
    }
    props.setMask(false)
    setSelectedTxSeleccionadas([]);
    setCheckedAllSeleccionadas(false);
    setSpinnerTxDisponibles(false)
    setSpinnerTxSeleccionadas(false);
  };

  const renderHeader = (title: string, typeTx: number) => {
    return (
      <div className="p-grid p-justify-between p-align-center">
        <div className="p-col-12 p-md-4" style={{ textAlign: "left" }}>
          <p className="t4">{title}</p>
        </div>
        <div className="p-col-12 p-md-8" style={{ textAlign: "end" }}>
          <div className="table-header-container">
            <div className="button-demo">
              <div className="template">
                <Button
                  className="eden-clr-blue p-0"
                  aria-label="Expandir"
                  onClick={() => expandAll(typeTx)}
                >
                  <i className="pi pi-plus px-2"></i>
                  <span className="px-3">Expandir Todo</span>
                </Button>
                <Button
                  className="eden-clr-blue p-0"
                  aria-label="Contraer"
                  onClick={() => collapseAll(typeTx)}
                >
                  <i className="pi pi-minus px-2"></i>
                  <span className="px-3">Contraer Todo</span>
                </Button>

                <Button
                  className="eden-clr-bluegray p-0"
                  aria-label="Exportar"
                  onClick={() => exportExcel(typeTx)}
                >
                  <i className="pi pi-download px-2"></i>
                  <span className="px-3">Exportar</span>
                </Button>
                {presentacionComercio.descripcion === INICIADA_COMERCIO || presentacionComercio.descripcion === RECHAZADA ? (
                  typeTx === TRANSACCIONES_DISPONIBLES ? (
                    <Button
                      className="eden-clr-green p-0"
                      aria-label="Incluir"
                      onClick={() => onIncluirTxDisponibles()}
                    >
                      <i className="pi pi-arrow-circle-down px-2"></i>
                      <span className="px-3">Incluir Seleccionados</span>
                      {selectedTxDisponibles.length > 0 && (
                        <Badge
                          className="mr-2"
                          value={String(selectedTxDisponibles.length)}
                          severity="success"
                        />
                      )}
                    </Button>
                  ) : (
                    <Button
                      className="eden-clr-red p-0"
                      aria-label="Excluir"
                      onClick={() => onExcluirTxSeleccionadas()}
                    >
                      <i className="pi pi-arrow-circle-up px-2"></i>
                      <span className="px-3">Excluir Seleccionados</span>
                      {selectedTxSeleccionadas.length > 0 && (
                        <Badge
                          className="mr-2"
                          value={String(selectedTxSeleccionadas.length)}
                          severity="success"
                        />
                      )}
                    </Button>
                  )
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const montoBodyTemplate = (monto: any) => {
    return (
      <React.Fragment>
        <NumericFormat
          value={monto}
          displayType={"text"}
          thousandSeparator={"."}
          decimalSeparator={","}
          prefix={"$"}
          decimalScale={2}
          fixedDecimalScale={true}
        />
      </React.Fragment>
    );
  };

  const rowExpansionTemplate = (data: any) => {
    return (
      <div className="orders-subtable">
        <DataTable
          value={data.detalles}
          responsiveLayout="stack"
          className="detTxDataTable"
          size="small"
        >
          <Column
            field="nombreProducto"
            header="Producto"
            style={presentacionEditable ? { width: "58%" } : { width: "65%" }}
          />
          <Column
            field="impuesto"
            header="Impuesto"
            body={(rowData)=> montoBodyTemplate(rowData.impuesto)}
            style={presentacionEditable ? { width: "20%" } : { width: "20%" }}
          />
          <Column
            field="monto"
            header="Monto"
            body={(rowData)=> montoBodyTemplate(rowData.monto)}
            style={presentacionEditable ? { width: "22%" } :{ width: "15%" }}
          />
        </DataTable>
      </div>
    );
  };
  const rowClass = (data: any) => {
    return {
      "row-accessories": data.category === "Accessories",
    };
  };
  const onSelectedTxDisponibles = (e: any) => {
    setCheckedAllDisponibles(!checkedAllDisponibles);
    setSelectedTxDisponibles(e.value);
  };
  const onSelectedTxSeleccionadas = (e: any) => {
    setCheckedAllSeleccionadas(!checkedAllSeleccionadas);
    setSelectedTxSeleccionadas(e.value);
  };

  const fechaBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <span className="p-column-title">Fecha De Solicitud</span>
        {GetDateLocal(rowData.fechaTransaccion)}
      </React.Fragment>
    );
  };

  function transaccionesConFechaMayor90ds(e:any) {
    const hoy = moment(new Date());
    const fechaPresentacion = moment(e.fechaTransaccion);
    const diferencia = moment(fechaPresentacion).diff(hoy, 'days');
    return Math.abs(diferencia) > 90;
  }

  const actionBodyTemplate = (rowData:any) => {
    let filterTxD = transaccionesConFechaMayor90ds(rowData);
    if(presentacionComercio.descripcion === INICIADA_COMERCIO && filterTxD){
      return (
        <React.Fragment>
            <div style={{display:'flex', alignItems:'center'}} >
               <span>{rowData.idCliente}</span> 
               <div className="flex align-items-center">
                      <Tooltip  target=".custom-target-icon" />
                      <i 
                      className="custom-target-icon pi pi-exclamation-circle ml-2 p-text-secondary p-overlay-badge" 
                      data-pr-tooltip={MESSAGE_TRX_FECHA_MAYOR_90_DS}
                      data-pr-position="right" 
                      data-pr-at="right+5 top" data-pr-my="left center-2" style={{ fontSize: '2rem', cursor: 'pointer',color: 'red' }}>
                      </i>
                </div>
               </div>
        </React.Fragment>
    );
    }else{
      return ( <React.Fragment>
            <div style={{display:'flex', alignItems:'center'}} >
               <span>{rowData.idCliente}</span> 
            </div>
        </React.Fragment>)
    }
    
  }

  return (
    <>
      <Toast ref={toast} position="bottom-right" />
      {(presentacionComercio.descripcion === INICIADA_COMERCIO || presentacionComercio.descripcion === RECHAZADA) && <div className="card mb-2">
          <DataTable
            ref={dt}
            header={() =>
              renderHeader(
                "Transacciones Disponibles",
                TRANSACCIONES_DISPONIBLES
              )
            }
            value={detailsTxDisponibles}
            selection={selectedTxDisponibles}
            onSelectionChange={(e) => onSelectedTxDisponibles(e)}
            expandedRows={expandedRowsDisponibles}
            onRowToggle={(e) => setExpandedRowsDisponibles(e.data)}
            responsiveLayout="stack"
            rowExpansionTemplate={rowExpansionTemplate}
            className="txDataTable"
            loading={spinnerTxDisponibles}
            dataKey="idTransaccion"
          >
            <Column expander={allowExpansion} style={{ width: "3%" }} />
            <Column
              field="idCliente"
              header="Cliente"
              style={{ width: "15%" }}
              body={actionBodyTemplate} 
            ></Column>
            <Column
              field="fechaTransaccion"
              body={fechaBodyTemplate}
              header="Fecha de solicitud"
              style={{ width: "15%" }}
            ></Column>
            <Column
              field="idEvent"
              header="Evento"
              style={{ width: "15%" }}
            ></Column>
            <Column
              field="idPresupuesto"
              header="Presupuesto"
              style={{ width: "15%" }}
            ></Column>
            <Column
              field="patente"
              header="Patente"
              style={{ width: "15%" }}
            ></Column>
            <Column
              field="monto"
              header="Monto"
              body={(rowData)=> montoBodyTemplate(rowData.monto)}
              style={{ width: "15%" }}
            ></Column>

            {presentacionEditable && (
              <Column
                className="column-selection"
                selectionMode={
                  detailsTxDisponibles.length == 0 ? "single" : "multiple"
                }
                header="Seleccionar"
                headerStyle={{ width: "7%" }}
              />
            )}
          </DataTable>
        </div>
      }
      <div className="card">
        <DataTable
          header={() =>
            renderHeader(
              "Transacciones Seleccionadas",
              TRANSACCIONES_SELECCIONADAS
            )
          }
          value={detailsTxSeleccionadas}
          selection={selectedTxSeleccionadas}
          onSelectionChange={(e) => onSelectedTxSeleccionadas(e)}
          expandedRows={expandedRowsSeleccionadas}
          onRowToggle={(e) => setExpandedRowsSeleccionadas(e.data)}
          responsiveLayout="stack"
          rowExpansionTemplate={rowExpansionTemplate}
          rowClassName={rowClass}
          className="txDataTable"
          loading={spinnerTxSeleccionadas}
          dataKey="idTransaccion"
        >
          <Column expander={allowExpansion} style={{ width: "3%" }} />
          <Column
            field="idCliente"
            header="Cliente"
            style={{ width: "15%" }}
            body={actionBodyTemplate} 
          ></Column>
          <Column
            field="fechaTransaccion"
            body={fechaBodyTemplate}
            header="Fecha de solicitud"
            style={{ width: "15%" }}
          ></Column>
          <Column
            field="idEvent"
            header="Evento"
            style={{ width: "15%" }}
          ></Column>
          <Column
            field="idPresupuesto"
            header="Presupuesto"
            style={{ width: "15%" }}
          ></Column>
          <Column
            field="patente"
            header="Patente"
            style={{ width: "15%" }}
          ></Column>
          <Column
            field="monto"
            header="Monto"
            body={(rowData)=> montoBodyTemplate(rowData.monto)}
            style={{ width: "15%" }}
          ></Column>

          {(presentacionComercio.descripcion === INICIADA_COMERCIO || presentacionComercio.descripcion === RECHAZADA) && (
              <Column
                className="column-selection"
                selectionMode={
                  detailsTxSeleccionadas.length == 0 ? "single" : "multiple"
                }
                header="Seleccionar"
                headerStyle={{ width: "7%" }}
                
              />
            )}
        </DataTable>
      </div>
    </>
  );
};

export default TransaccionesDetallesMF;
